import { type ActionContext } from 'vuex'

import { useAuthStore } from '@/auth/useAuthStore'
import { type CoreLocation, type CoreState } from '@/core/store/types'
import { OlympusClient } from '@/OlympusClient'

import { useCoreStore } from '../../useCoreStore'

export const loadBrand = async (
  { commit, dispatch }: ActionContext<CoreState, unknown>,
  brandId: string
): Promise<void> => {
  const coreStore = useCoreStore()
  const authStore = useAuthStore()

  const { brand, locations, theme, session } =
    await OlympusClient.dashboard.v2.brands.brand.core({
      headers: {
        'X-Active-Brand-ID': brandId,
      },
      params: {
        brandId,
      },
    })

  await dispatch('locations/setAll', locations)

  commit('SET_BRANDS', [brand])
  coreStore.setActiveBrand({
    ...brand,
    locations: locations as CoreLocation[],
    theme,
  })
  commit('SET_THEME', theme)

  if (session) await authStore.setBrandSession(session)
}
